import client from 'api/client';

import { createURLParams } from 'utils/urls';

export const eligibilityCheck = payload => client.post('members/eligibility-check/', payload);

export const getMemberState = payload => client.post('members/get-member-state/', payload);

// TODO: Duplicate with `getCoverageDataByCode`, remove when switch to react query
export const getCoverageByCodes = coverageCodes =>
  client.post('members/coverage-code-lookup/', { coverageCodes });

export const getCoverageDataByCode = async coverageCode => {
  const { data } = await client.post('members/coverage-code-lookup/', {
    coverageCodes: [coverageCode],
  });
  return data;
};

export const searchByCaseNumber = payload =>
  client.post('members/case-number-eligibility/', payload);

export const searchByMemberNumber = payload =>
  client.post('members/member-number-eligibility/', payload);

export const getPreviousClients = firmId => client.get(`members/previous-clients/?firm=${firmId}`);

export const createMembersEntry = payload => client.post('members/create-member/', payload);

export const getClaimsByMember = payload => client.post('members/claims-for-member/', payload);

export const checkCoverageAtDate = (mlpId, date) =>
  client.get(`members/coverage-by-date/?mlp_id=${mlpId}&date=${date}`);

export const getEnrolledMember = async payload => {
  const { data } = await client.post(`members/enrolled-member/`, payload);
  return data;
};

export const getEnrollmentHistory = async payload => {
  const { data } = await client.post(`members/enrollment-history/`, payload);
  return data;
};

export const getMemberContactInformation = eligibilityId => {
  const queryParams = createURLParams({ eligibilityId });
  return client.get(`members/get-member-contact-information/`, { params: queryParams });
};
